import React, { useEffect, useState } from "react";
import config from "../../config/config";
import DASHBOARD_ORDERDETAILS from "../../components/DASHBOARD_ORDERDETAILS";
import Loader from "../components/Loader";

function Orders() {
  const { API_BASE_URL } = config;
  const [loader, setLoader] = useState(false);
  const [orderDetails, setOrderDetails] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    const auth = JSON.parse(localStorage.getItem("auth")) || {};
    const role = (auth.role).trim();
    const userId = auth.userId;

    const fetchOrderDetails = async () => {
      try {
        setLoader(true);
        const response = await fetch(
          `${API_BASE_URL}/Home/getorderdetails`,
          {
            method: "POST",
            headers: {
              Token: "28a076d9-b5fd-11ee-871f-74867ad6e338",
              UniqueId: userId,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
          }
        );

        if (!response.ok) return;
        

        const res = await response.json();
        
       
        
        const ordersArray = res.data || res.result || res.orders || res;
         
        if (!Array.isArray(ordersArray)) {
          
          setOrderDetails([]);
          return;
        }

        // ✅ ROLE BASED FILTERING
        if (role === "Salesperson") {
          const filtered = ordersArray.filter(
            (order) => String(order.orderplaceid) === String(userId)
          );
          setOrderDetails(filtered);
        } else {
          // Admin sees all
          setOrderDetails(ordersArray);
        }
      } catch (error) {
        console.error("Error fetching order details:", error);
      } finally {
        setLoader(false);
      }
    };

    fetchOrderDetails();
  }, [API_BASE_URL]);

  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return "-";
    const dateTime = new Date(dateTimeString);
    return `${dateTime.toLocaleDateString()} ${dateTime.toLocaleTimeString()}`;
  };

  return (
    <>
    {loader && <Loader text="Fetching Orders..." />}
    <div className="bg-gray-100 p-2 sm:p-4 h-full overflow-y-auto">
      <h4 className="text-base sm:text-lg font-bold text-gray-800 mb-3">
        Orders
      </h4>

      {/* 📱 MOBILE VIEW */}
      <div className="space-y-3 md:hidden">
        {orderDetails.map((order) => (
          <div
            key={order.orderId}
            className="bg-white rounded-lg shadow-sm p-3"
          >
            <div className="flex justify-between items-center mb-1">
              <span className="text-sm font-semibold">
                Order #{order.orderId}
              </span>
              <span className="text-sm font-bold text-green-600">
                ₹ {order.total}
              </span>
            </div>

            <div className="text-xs text-gray-600 space-y-1">
              <p>
                <span className="font-medium">Name:</span> {order.name}
              </p>
              <p>
                <span className="font-medium">Order:</span>{" "}
                {formatDateTime(order.orderDate)}
              </p>
              <p>
                <span className="font-medium">Payment:</span>{" "}
                {formatDateTime(order.paymentDate)}
              </p>
            </div>

            <button
              onClick={() => setSelectedOrder(order)}
              className="mt-3 w-full bg-yellow-400 text-black text-sm font-semibold py-2 rounded-md active:scale-95"
            >
              View Details
            </button>
          </div>
        ))}
      </div>

      {/* 🖥️ DESKTOP / TABLET VIEW */}
      <div className="hidden md:block bg-white rounded-lg shadow-sm overflow-x-auto">
        <table className="w-full text-sm text-left text-gray-700">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="px-4 py-3 font-semibold">Order ID</th>
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Total</th>
              <th className="px-4 py-3 font-semibold">Order Date</th>
              <th className="px-4 py-3 font-semibold">Payment Date</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {orderDetails.map((order) => (
              <tr key={order.orderId} className="hover:bg-gray-50">
                <td className="px-4 py-3">{order.orderId}</td>
                <td className="px-4 py-3">{order.name}</td>
                <td className="px-4 py-3 font-semibold">
                  ₹ {order.total}
                </td>
                <td className="px-4 py-3">
                  {formatDateTime(order.orderDate)}
                </td>
                <td className="px-4 py-3">
                  {formatDateTime(order.paymentDate)}
                </td>
                <td className="px-4 py-3">
                  <button
                    onClick={() => setSelectedOrder(order)}
                    className="bg-yellow-400 px-3 py-1 rounded-md font-semibold text-sm"
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 🔍 ORDER DETAILS MODAL */}
      {selectedOrder && (
        <DASHBOARD_ORDERDETAILS
          order={selectedOrder}
          onClose={() => setSelectedOrder(null)}
        />
      )}
    </div>
    </>
  );
}

export default Orders;





// import React, { useEffect, useState } from "react";
// import config from "../../config/config";
// import DASHBOARD_ORDERDETAILS from "../../components/DASHBOARD_ORDERDETAILS";

// function Orders() {
//   const { API_BASE_URL } = config;
//   const [orderDetails, setOrderDetails] = useState([]);
//   const [selectedOrder, setSelectedOrder] = useState(null);
  
//   const [userRole, setUserRole] = useState(""); // For storing user role (Admin or Salesperson)
//   const loggedInUserId = JSON.parse(localStorage.getItem('auth'))?.userId; // Replace with the actual logged-in user's ID

//   useEffect(() => {

//     const role = JSON.parse(localStorage.getItem('auth'))?.role;
//     setUserRole(role);


//     const fetchOrderDetails = async () => {
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/Home/getorderdetails`,
//           {
//             method: "POST",
//             headers: {
//               Token: "28a076d9-b5fd-11ee-871f-74867ad6e338",
//               UniqueId: loggedInUserId,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({}),
//           }
//         );

//         if (response.ok) {
//           const data = await response.json();
//           if (userRole === "Salesperson") {
//             const filteredOrders = data.filter(order => order.salespersonId === loggedInUserId);
//             setOrderDetails(filteredOrders);

//           } else {
//             setOrderDetails(data);
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching order details:", error);
//       }
//     };

//     fetchOrderDetails();
//   }, [API_BASE_URL]);

//   const formatDateTime = (dateTimeString) => {
//     if (!dateTimeString) return "-";
//     const dateTime = new Date(dateTimeString);
//     return `${dateTime.toLocaleDateString()} ${dateTime.toLocaleTimeString()}`;
//   };

//   return (
//     <div className="bg-gray-100 p-2 sm:p-4 h-full overflow-y-auto">
//       <h4 className="text-base sm:text-lg font-bold text-gray-800 mb-3">
//         Orders
//       </h4>

//       {/* 📱 MOBILE VIEW (CARDS) */}
//       <div className="space-y-3 md:hidden">
//         {orderDetails.map((order) => (
//           <div
//             key={order.orderId}
//             className="bg-white rounded-lg shadow-sm p-3"
//           >
//             <div className="flex justify-between items-center mb-1">
//               <span className="text-sm font-semibold">
//                 Order #{order.orderId}
//               </span>
//               <span className="text-sm font-bold text-green-600">
//                 ₹ {order.total}
//               </span>
//             </div>

//             <div className="text-xs text-gray-600 space-y-1">
//               <p>
//                 <span className="font-medium">Name:</span> {order.name}
//               </p>
//               <p>
//                 <span className="font-medium">Order:</span>{" "}
//                 {formatDateTime(order.orderDate)}
//               </p>
//               <p>
//                 <span className="font-medium">Payment:</span>{" "}
//                 {formatDateTime(order.paymentDate)}
//               </p>
//             </div>

//             <button
//               onClick={() => setSelectedOrder(order)}
//               className="mt-3 w-full bg-yellow-400 text-black text-sm font-semibold py-2 rounded-md active:scale-95"
//             >
//               View Details
//             </button>
//           </div>
//         ))}
//       </div>

//       {/* 🖥️ TABLET / DESKTOP VIEW */}
//       <div className="hidden md:block bg-white rounded-lg shadow-sm overflow-x-auto">
//         <table className="w-full text-sm text-left text-gray-700">
//           <thead className="bg-gray-50 border-b">
//             <tr>
//               <th className="px-4 py-3 font-semibold">Order ID</th>
//               <th className="px-4 py-3 font-semibold">Name</th>
//               <th className="px-4 py-3 font-semibold">Total</th>
//               <th className="px-4 py-3 font-semibold">Order Date</th>
//               <th className="px-4 py-3 font-semibold">Payment Date</th>
//               <th className="px-4 py-3"></th>
//             </tr>
//           </thead>

//           <tbody className="divide-y">
//             {orderDetails.map((order) => (
//               <tr key={order.orderId} className="hover:bg-gray-50">
//                 <td className="px-4 py-3">{order.orderId}</td>
//                 <td className="px-4 py-3">{order.name}</td>
//                 <td className="px-4 py-3 font-semibold">
//                   ₹ {order.total}
//                 </td>
//                 <td className="px-4 py-3">
//                   {formatDateTime(order.orderDate)}
//                 </td>
//                 <td className="px-4 py-3">
//                   {formatDateTime(order.paymentDate)}
//                 </td>
//                 <td className="px-4 py-3">
//                   <button
//                     onClick={() => setSelectedOrder(order)}
//                     className="bg-yellow-400 px-3 py-1 rounded-md font-semibold text-sm"
//                   >
//                     View
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* 🔍 ORDER DETAILS MODAL */}
//       {selectedOrder && (
//         <DASHBOARD_ORDERDETAILS
//           order={selectedOrder}
//           onClose={() => setSelectedOrder(null)}
//         />
//       )}
//     </div>
//   );
// }

// export default Orders;
